angular.module('picmonic-common').filter('countdown', function () {
  return function (input) {
    if (input < 60) {
      return input + 's';
    }

    return Math.floor(input / 3600) + 'h ' + Math.floor((input % 3600) / 60) + 'm ' + (input % 60) + 's';
  };
});
